import { render } from "./spinnerComponent.vue?vue&type=template&id=2aa48a46&scoped=true"
import script from "./spinnerComponent.vue?vue&type=script&lang=js"
export * from "./spinnerComponent.vue?vue&type=script&lang=js"

import "./spinnerComponent.vue?vue&type=style&index=0&id=2aa48a46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa48a46"]])

export default __exports__